import { css } from '@emotion/css'
import { fontSize, fontWeight, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  subHeading: css({
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.medium,
    margin: shorthandHelper([spacing.medium, 0]),
  }),
}

export default styles
